if (!customElements.get('wls-video')) {
    class WLSVideo extends HTMLElement {
      constructor() {
        super();
  
        this.classes = {
          playButton: 'js-wls-video-play-button',
          playing: 'playing',
        };
  
        this.selectors = this.getSelectors();
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
          threshold: 0.5,
        });
      }
  
      getSelectors() {
        return {
          playButton: this.querySelector(`.${this.classes.playButton}`),
          video: this.querySelector('video'),
        };
      }
  
      connectedCallback() {
        if (this.selectors.video) {
          this.observer.observe(this);
  
          // Handle autoplay videos
          if (this.selectors.video.hasAttribute('autoplay')) {
            this.handleAutoplayVideo();
          } else if (this.selectors.playButton) {
            this.selectors.playButton.addEventListener('click', this.videoPlayingHandler.bind(this));
          }
        }
      }
  
      handleAutoplayVideo() {
        // Remove click listener if it exists
        if (this.selectors.playButton) {
          this.selectors.playButton.style.pointerEvents = 'none';
        }
  
        // Add playing class when video starts playing
        this.selectors.video.addEventListener('playing', () => {
          this.classList.add(this.classes.playing);
        });
      }
  
    
      disconnectedCallback() {
        if (this.selectors.playButton && !this.selectors.video?.hasAttribute('autoplay')) {
          this.selectors.playButton.removeEventListener('click', this.videoPlayingHandler);
        }
        this.observer.disconnect();
      }
  
      handleIntersection(entries) {
        entries.forEach((entry) => {
          if (!entry.isIntersecting && !this.selectors.video.paused) {
            this.videoPause();
          }
        });
      }
  
      pauseSyncedVideos() {
        if (this.hasAttribute('data-sync-pause')) {
          const allSyncedVideos = document.querySelectorAll('wls-video[data-sync-pause]');
          allSyncedVideos.forEach((videoElement) => {
            if (videoElement !== this && !videoElement.querySelector('video')?.paused) {
              videoElement.classList.remove(this.classes.playing);
              videoElement.querySelector('video')?.pause();
            }
          });
        }
      }
  
      videoPlayingHandler() {
        if (this.selectors.video.paused) {
          this.pauseSyncedVideos();
          this.videoPlay();
        } else {
          this.videoPause();
        }
      }
  
        // Play video
      videoPlay() {
        this.selectors.video.play();
        this.classList.add(this.classes.playing);
      }
  
    //   Pause video
      videoPause() {
        // Only pause if it's not an autoplay video
        if (!this.selectors.video.hasAttribute('autoplay')) {
          this.selectors.video.pause();
          this.classList.remove(this.classes.playing);
        }
      }
    }
  
    customElements.define('wls-video', WLSVideo);
  }
  